import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import {
  GET_COOPERATION_WAREHOUSES_LISTING,
  CooperationWarehouseListingResponse,
  CooperationWarehouseFiltersTypeInput,
  CooperationWarehouseType
} from "../graphql/queries/getCooperationWarehouses";
import { formatTimeRangeToISO } from "../../../../utils/dateTimeUtils";

export interface CooperationWarehouseQueryResult {
  warehouseData: CooperationWarehouseType[];
  loading: boolean;
  refetch: (variables?: any) => Promise<any>;
  totalElements: number;
  buildQueryVariables: () => any;
}

export const useCooperationWarehouseQuery = (
  filters: CooperationWarehouseFiltersTypeInput,
  currentPage: number,
  pageSize: number
): CooperationWarehouseQueryResult => {
  const [warehouseData, setWarehouseData] = useState<CooperationWarehouseType[]>([]);
  const [total, setTotal] = useState(0);

  const buildQueryVariables = () => {
    const timeRanges = {
      createdAt: formatTimeRangeToISO(filters.createdAt),
      updatedAt: formatTimeRangeToISO(filters.updatedAt)
    }

    const queryFilters = {
      ...filters,
      ...timeRanges
    };

    return {
      filter: queryFilters,
      pageRequest: {
        page: currentPage,
        size: pageSize,
        sortBy: "id",
        sortDirection: "DESC"
      }
    };
  };

  // 执行查询
  const { data, loading: queryLoading, refetch } = useQuery<CooperationWarehouseListingResponse>(
    GET_COOPERATION_WAREHOUSES_LISTING,
    {
      variables: buildQueryVariables(),
      fetchPolicy: 'network-only',
      skip: !filters.warehouseId
    }
  );

  // 当数据变化时更新状态
  useEffect(() => {
    const responseData = data?.getCooperationWarehouseListing?.content;
    if (responseData) {
      setWarehouseData(responseData);
    } else {
      setWarehouseData([]);
    }
    
    const totalElements = data?.getCooperationWarehouseListing?.totalElements;
    if (totalElements !== undefined) {
      setTotal(totalElements);
    } else {
      setTotal(0);
    }
  }, [data]);

  return {
    warehouseData,
    loading: queryLoading,
    refetch,
    totalElements: total,
    buildQueryVariables
  };
}; 